export default __webpack_public_path__ + "static/media/Rectangle 4.895c6f32.png";